export const API_URL = process.env.REACT_APP_API_URL;
export const CHAIN_ID = process.env.REACT_APP_CHAIN_ID;
export const AIRDROP_CONTRACT_ADDRESS = process.env.REACT_APP_AIRDROP_CONTRACT_ADDRESS;
